import { render } from "./TotalProgressDonut.vue?vue&type=template&id=0ac5a1ca"
import script from "./TotalProgressDonut.vue?vue&type=script&lang=js"
export * from "./TotalProgressDonut.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__